// src/services/signupPointHelper.js
// 회원가입 완료 시 호출하세요 (RegisterScreen의 회원가입 성공 직후)
// 사용 예:
//   import { grantSignupPoints } from '../../services/signupPointHelper';
//   await grantSignupPoints(user.uid);
// 44차: console.log / console.warn 제거 (프로덕션 대응)
// 53차: 포인트 보안 이관
//        클라 직접 pointHistory addDoc / users.points increment 제거
//        → CF grantSignupPointsCF 호출로 교체
//        서버에서 signupPointGranted 플래그로 uid당 1회 중복 지급 방지

import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export const grantSignupPoints = async (uid) => {
  if (!uid) return;
  try {
    const cf = httpsCallable(functions, 'grantSignupPointsCF');
    await cf({ uid });
  } catch (err) {
    // 'already-exists': 이미 지급된 경우 — 재시도 무시
    // 기타 CF 실패 — 회원가입 자체는 이미 완료된 상태이므로 무음 처리
    // 프로덕션에서 Sentry 등 외부 로거 연동 권장
  }
};

// 80차 계속: 친구 초대 리워드 — 가입 화면에서 "초대코드(선택)"를 입력했을 때만 호출.
// grantSignupPoints와 동일하게 실패해도(잘못된 코드/자기 자신/중복 등) 회원가입 자체는
// 이미 끝난 상태이므로 무음 처리 — applyReferralCF가 코드 유효성/중복 검증을 서버에서
// 전담하므로 여기선 별도 검증 없이 그대로 전달.
export const applyReferral = async (inviterUid) => {
  if (!inviterUid || !inviterUid.trim()) return;
  try {
    const cf = httpsCallable(functions, 'applyReferralCF');
    await cf({ inviterUid: inviterUid.trim() });
  } catch (err) {
    // 잘못된 초대코드/자기 자신/이미 사용함 등 — 회원가입 자체는 이미 완료됐으므로 무음 처리
  }
};